import axios from 'axios'
import config from '@/config'

const jobSearchService = {
  getJobs(context, data) {
    return new Promise((resolve, reject) => {
      let queryParam = '?'

      queryParam += data.textSearch ? 'textSearch=' + data.textSearch : ''
      queryParam += data.jobTitle ? '&jobTitle=' + data.jobTitle : ''
      queryParam += data.jobLocation ? '&jobLocation=' + data.jobLocation : ''
      queryParam += data.companyName ? '&companyName=' + data.companyName : ''
      queryParam += data.careerStage ? '&careerStage=' + data.careerStage : ''
      queryParam += data.graduation ? '&graduationType=' + data.graduation : ''
      queryParam += data.employmentType ? '&employmentType=' + data.employmentType : ''
      queryParam += data.businessType ? '&businessType=' + data.businessType : ''
      queryParam += data.position ? '&position=' + data.position : ''
      queryParam += '&count=' + data.count
      queryParam += '&page=' + data.page
      queryParam += data.candidateEmail ? '&candidateEmail=' + data.candidateEmail : ''

      if (queryParam[1] === '&') {
        queryParam = '?' + queryParam.substr(2, queryParam.length - 1)
      }

      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + `/jobad/search${queryParam}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getJobsNewApi(context, data) {
    console.log('PARAMS: ', data)
    return new Promise((resolve, reject) => {
      let queryParam = '?'

      queryParam += data.textSearch ? 'textSearch=' + data.textSearch : ''
      queryParam += data.jobTitle ? '&jobTitle=' + data.jobTitle : ''
      queryParam += data.jobLocation ? '&jobLocation=' + data.jobLocation : ''
      queryParam += data.companyName ? '&companyName=' + data.companyName : ''
      queryParam += data.careerStage ? '&careerStage=' + data.careerStage : ''
      queryParam += data.graduation ? '&graduationType=' + data.graduation : ''
      queryParam += data.employmentType ? '&employmentType=' + data.employmentType : ''
      queryParam += data.businessType ? '&businessType=' + data.businessType : ''
      queryParam += data.position ? '&position=' + data.position : ''
      queryParam += '&count=' + data.count
      queryParam += '&page=' + data.page
      queryParam += data.candidateEmail ? '&candidateEmail=' + data.candidateEmail : ''

      if (queryParam[1] === '&') {
        queryParam = '?' + queryParam.substr(2, queryParam.length - 1)
      }

      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + `/jobad/search/app${queryParam}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getApplications(context, data) {
    return new Promise((resolve, reject) => {
      let queryParam = '?'

      queryParam += '&count=40'
      // + data.count
      queryParam +=
        '&page=1' +
        // data.page

        axios({
          method: 'GET',
          url: config.BASE_API_URL_V2 + `/jobad/applied/list${queryParam}`,
        })
          .then(response => {
            resolve(response.data)
          })
          .catch(e => {
            reject(e.response)
          })
    })
  },
  markJob(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + `/jobad/mark`,
        data: data,
      })
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  unmarkJob(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + `/jobad/mark/remove`,
        data: data,
      })
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
}

export default jobSearchService
